import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { heroImages } from "../data/mock";
import { PageHero, Reveal, CTASection } from "../components/common";
import api from "../lib/api";
import { CalendarDays, ArrowRight, Loader2 } from "lucide-react";

const fmt = (d) => new Date(d).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });

const Blog = () => {
  const [posts, setPosts] = useState(null);
  useEffect(() => { api.getBlog().then(setPosts).catch(() => setPosts([])); }, []);
  return (
  <>
    <PageHero image={heroImages[2].img} eyebrow="Journal" title="Fishing Reports & Guides" sub="Tips, species guides and the latest from the water in San Juan del Sur, Nicaragua." />
    <section className="py-14">
      <div className="container-x">
        {posts === null ? (
          <div className="flex justify-center py-16"><Loader2 className="h-8 w-8 animate-spin text-[#f5a524]" /></div>
        ) : (
        <div className="grid gap-8 md:grid-cols-3">
        {posts.map((p, i) => (
          <Reveal key={p.slug} delay={i * 0.08}>
            <Link to={`/blog/${p.slug}`} className="card-hover group flex h-full flex-col rounded-2xl overflow-hidden bg-[#0e2740] border border-white/10">
              <div className="relative h-52 overflow-hidden">
                <img src={p.cover} alt={p.title} className="h-full w-full object-cover transition duration-500 group-hover:scale-110" />
                <span className="absolute top-3 left-3 rounded-full bg-[#f5a524] px-3 py-1 text-xs font-bold text-[#0a1f33]">{p.tag}</span>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <p className="text-xs text-slate-400 flex items-center gap-1"><CalendarDays className="h-3.5 w-3.5" /> {fmt(p.created_at)} · {p.author}</p>
                <h3 className="font-heading text-xl text-white mt-2 leading-snug">{p.title}</h3>
                <p className="text-sm text-slate-300 mt-2 flex-1">{p.excerpt}</p>
                <span className="text-[#f5a524] text-sm mt-4 inline-flex items-center gap-1">Read more <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition" /></span>
              </div>
            </Link>
          </Reveal>
        ))}
        </div>
        )}
      </div>
    </section>
    <CTASection image={heroImages[1].img} />
  </>
  );
};

export default Blog;
